<template lang="html">
  <div class="profile-my-purchases-wrapper">
    <div v-if="windowWidth > 1000">
      <div class="actions-wrapper">
        <div class="btn-dropdown-wrapper">
          <div @click="navigateToHome()" class="btn dark-blue ">
            <img src="@/assets/icons/plusWhite.png" alt="trash icon" />
            {{ $t("profile.purchase.newPurchase") }}
          </div>
          <dropdown
            :defaultText="$t('dropdown.sort')"
            :selected="sortSelected"
            :list="sortList"
            :removable="true"
            @remove="(sortSelected = null), getMyPurchases()"
            @changeOption="(sortSelected = $event), getMyPurchases()"
          />
        </div>
        <div class="search-wrapper">
          <input-view
            @keyup="(page = 1), getMyPurchases()"
            v-model="search"
            type="text"
            :label="$t('nav.search')"
            name=""
            value=""
            icon="mdi:search"
          />
        </div>
      </div>
      <table v-if="purchases.length > 0">
        <thead>
          <tr>
            <td>{{ $t("profile.purchase.productService") }}</td>
            <td>{{ $t("profile.purchase.seller") }}</td>
            <td>{{ $t("profile.purchase.quantity") }}</td>
            <td>{{ $t("profile.purchase.price") }}</td>
            <td>{{ $t("profile.purchase.date") }}</td>
            <td>{{ $t("profile.purchase.status") }}</td>
            <td style="width: 40px"></td>
            <td style="width: 40px"></td>
            <td style="width: 40px"></td>
            <td style="width: 40px"></td>
          </tr>
        </thead>
        <tbody>
          <template v-for="(purchase, index) in purchases">
            <tr
              :class="{
                deleted: purchase.archived === 1 || purchase.expired === 1
              }"
              :key="index"
              @click="purchase.open = !purchase.open"
            >
              <td>
                <span
                  :title="$t('main.viewProduct')"
                  class="underline"
                  @click="navigateToAd(purchase.pro_id, $event)"
                >
                  {{ purchase.pro_name }}
                </span>
              </td>
              <td>
                {{ purchase.usr_name }}
              </td>
              <td>
                {{ purchase.off_quantity }}
              </td>
              <td>{{ purchase.prc_price }} {{ purchase.cur_id }}</td>
              <td>
                {{ purchase.pro_expiry.substring(0, 10) }}
              </td>
              <td>
                <tag-display
                  :color="
                    getTagColor(
                      purchase.off_status,
                      purchase.sold_out,
                      purchase.expired
                    )
                  "
                >
                  {{
                    getStatus(
                      purchase.off_status,
                      purchase.sold_out,
                      purchase.expired
                    )
                  }}
                </tag-display>
              </td>
              <td>
                <div class="icon-wrapper">
                  <img
                    style="height: 10px;"
                    src="@/assets/icons/eye.svg"
                    alt="eye icon"
                  />
                </div>
              </td>
              <td
                v-if="purchase.editable === 1"
                @click="openChangeOfferModal(purchase, $event)"
              >
                <div class="icon-wrapper">
                  <img
                    :title="$t('main.edit')"
                    src="@/assets/icons/pen.png"
                    alt="pen icon"
                  />
                </div>
              </td>
              <td v-else></td>
              <td
                v-if="
                  purchase.off_status === 1 &&
                    purchase.archived === 0 &&
                    purchase.expired === 0 &&
                    purchase.sold_out === 0
                "
                @click="openConfirmModal(purchase, $event)"
              >
                <div class="icon-wrapper">
                  <img
                    :title="$t('main.giveUp')"
                    src="@/assets/icons/reject.png"
                    alt="x icon"
                  />
                </div>
              </td>
              <td v-else></td>
              <td
                v-if="purchase.can_hide === 1"
                @click="archive(purchase, $event)"
              >
                <div class="icon-wrapper">
                  <img src="@/assets/icons/closeRed.png" alt="close icon" />
                </div>
              </td>
              <td v-else></td>
            </tr>
            <tr
              class="dropdown-row"
              :key="index + 'd'"
              :class="{ active: purchase.open }"
            >
              <td colspan="100%">
                <div class="dropdown">
                  <div class="info-wrapper">
                    <div class="left">
                      <div class="header">
                        {{ $t("profile.purchase.details") }}
                      </div>
                      <div>
                        <div class="info">
                          <span class="info-key"
                            >{{ $t("profile.purchase.purchaseTerms") }}:</span
                          >
                          <div class="info-value">
                            {{ getTranslation(purchase.off_type) }}
                          </div>
                        </div>
                        <div class="info">
                          <span class="info-key"
                            >{{ $t("profile.purchase.offeredPrice") }}:</span
                          >
                          <div class="info-value">
                            {{ purchase.prc_price }} {{ purchase.cur_id }}
                          </div>
                        </div>
                        <div class="info">
                          <span class="info-key"
                            >{{ $t("item.currentPrice") }}:</span
                          >
                          <div class="info-value">
                            {{ purchase.current_price }} {{ purchase.cur_id }}
                          </div>
                        </div>
                      </div>
                      <div class="info">
                        <span class="info-key"
                          >{{ $t("profile.purchase.sellerRating") }}:</span
                        >
                        <div class="info-value">
                          <rating :rating="parseFloat(purchase.usr_rating)" />
                        </div>
                      </div>
                      <div
                        @click="openOffersList(purchase)"
                        class="btn dark-blue outlined fit-content"
                      >
                        {{ $t("profile.purchase.otherList") }}
                      </div>
                    </div>
                    <div class="right">
                      <div class="share-and-rate-button">
                        <div class="header">
                          {{ $t("profile.purchase.rate") }}:
                        </div>
                        <div
                          class="info share"
                          v-if="seeExpiry(purchase.pro_expiry)"
                        >
                          <div>{{ $t("profile.purchase.shareProduct") }}:</div>
                          <div class="info-value iconsVal">
                            <ShareNetwork
                              network="Facebook"
                              :url="createUrl(purchase.pro_id)"
                              :title="purchase.pro_name"
                              :description="purchase.pro_description"
                              :quote="purchase.pro_description"
                              hashtags="eBerza"
                            >
                              <img
                                style="cursor: pointer; margin-right: 5px"
                                :src="require('@/assets/icons/facebook.png')"
                                alt="facebook logo"
                              />
                            </ShareNetwork>
                            <ShareNetwork
                              network="Twitter"
                              :url="createUrl(purchase.pro_id)"
                              :title="purchase.pro_name"
                              :description="purchase.pro_description"
                              :quote="purchase.pro_description"
                              hashtags="eBerza"
                            >
                              <img
                                style="cursor: pointer; width: 26px;"
                                :src="require('@/assets/icons/XLogo.png')"
                                alt="twitter logo"
                              />
                            </ShareNetwork>
                            <ShareNetwork
                              network="email"
                              :url="
                                $t('txtemail') +
                                  createUrl(purchase.pro_id) +
                                  '\n'
                              "
                              :title="purchase.pro_name"
                              :description="
                                purchase.pro_description + $t('txtemail2')
                              "
                              :quote="purchase.pro_description"
                              hashtags="eBerza"
                            >
                              <img
                                class="imgShareIcon"
                                :src="require('@/assets/icons/sharemail.png')"
                                alt="email share"
                              />
                            </ShareNetwork>
                          </div>
                        </div>
                      </div>
                      <div class="rate-wrapper">
                        <div class="info">
                          <RateUser
                            :rating="rate"
                            @update-rating="rate = $event"
                          />
                        </div>
                        <div class="info">
                          <input-view
                            v-model="comment"
                            max-length="300"
                            type="textarea"
                            :label="$t('profile.purchase.comment')"
                          ></input-view>
                        </div>

                        <div
                          style="width: 200px"
                          @click="rateSeller(purchase.off_id)"
                          class="btn dark-blue"
                        >
                          {{ $t("profile.purchase.rateSeller") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="empty" v-else>
        {{ $t("main.noPurchases") }}
      </div>
      <div v-if="purchases.length > 0" class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="pageCount"
          :prev-text="getPaginationImages('Left')"
          :next-text="getPaginationImages('Right')"
          :container-class="'pagination'"
          :page-class="'page'"
          :click-handler="changePage"
        >
        </paginate>
      </div>
    </div>
    <div v-if="windowWidth <= 1000">
      <my-purchases-mobile
        :_sortSelected="sortSelected"
        :_search="search"
        :_page="page"
        @changeSort="(sortSelected = $event), getMyPurchases()"
        @changeSearch="(search = $event), getMyPurchases()"
        @changePage="(page = $event), getMyPurchases()"
      />
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import Rating from "@/components/rating.vue";
import myPurchasesMobile from "../profileMobile/myPurchasesMobile";
import Dropdown from "@/components/dropdown.vue";
import testInput from "@/components/shared/testInput.vue";
import { api } from "@/api";
import TagDisplay from "../shared/TagDisplay.vue";
import RateUser from "../shared/RateUser.vue";
export default {
  name: "profileMyPurchases",
  components: {
    Rating,
    myPurchasesMobile,
    Dropdown,
    InputView: testInput,
    TagDisplay,
    RateUser
  },
  data() {
    return {
      purchases: [],
      rate: null,
      comment: null,
      page: 1,
      pageCount: 0,
      search: null,
      windowWidth: window.innerWidth,
      sortSelected: null
    };
  },
  mounted() {
    this.getMyPurchases();
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  activated() {
    this.purchases = [];
    this.page = 1;
    this.getMyPurchases();
  },
  methods: {
    fixRate() {
      if (parseInt(this.rate) > 5) {
        this.rate = 5;
      } else if (parseInt(this.rate) < 1) {
        this.rate = 1;
      }
    },
    getMyPurchases() {
      let params = {
        page: this.page
      };
      if (this.sortSelected) {
        params.sort = this.sortSelected.value;
      }
      if (this.search && this.search !== "") {
        params.search = this.search;
      }
      api
        .getMyPurchases(params)
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.pageCount = res.data.page_count;
          this.purchases = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    rateSeller(id) {
      if (this.rate || this.comment) {
        let params = {
          id: id
        };
        if (this.rate) {
          params.rat_rating = this.rate;
        }
        if (this.comment) {
          params.rat_comment = this.comment;
        }
        api
          .rateUser(params)
          .then(res => {
            console.log(res);
            this.$toast.success(this.$t("main.rateSuccess"), {
              duration: 8000
            });
          })
          .catch(e => {
            console.log(e);
            this.$toast.error(this.$t("main.rateError"), {
              duration: 8000
            });
          })
          .finally(() => {
            this.rate = null;
            this.comment = null;
          });
      } else {
        this.$toast.error(this.$t("main.rateError"), {
          duration: 8000
        });
      }
    },
    archive(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.archiveOffer"),
        ok: () => {
          this.archiveOffer(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    archiveOffer(data) {
      let params = {
        off_id: data.off_id
      };
      api
        .deleteOfferFromArchive(params)
        .then(res => {
          this.getMyPurchases();
        })
        .catch(e => {
          console.log(e);
        });
    },
    openConfirmModal(data, e) {
      console.log("confrim yes no");
      e.stopPropagation();
      let modalData = {
        title: this.$t("modal.giveUpOfferTitle"),
        ok: () => {
          this.changeStatus(data);
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmYesNoModal"
      };
      eventBus.$emit("openModal", params);
    },
    openChangeOfferModal(data, e) {
      e.stopPropagation();
      let modalData = {
        title: this.$t("main.changeOffer"),
        id: data.pro_id,
        off_quantity: data.off_quantity,
        off_id: data.off_id,
        ok: () => {
          this.getMyPurchases();
        }
      };
      let params = {
        modalData: modalData,
        component: "changeOffer"
      };
      eventBus.$emit("openModal", params);
    },
    changeStatus(data) {
      let params = {
        id: data.off_id
      };
      api
        .changeOffer(params)
        .then(res => {
          console.log("changeOffer - true");
          this.$toast.success(this.$t("main.giveUpOfferSuccess"), {
            duration: 8000
          });
        })
        .catch(e => {
          console.log("changeOffer - false");
          this.$toast.error(this.$t("main.giveUpOfferError"), {
            duration: 8000
          });
        })
        .finally(() => {
          this.getMyPurchases();
        });
    },
    openOffersList(purchase) {
      let params = {
        modalData: purchase,
        component: "productBuyers"
      };
      eventBus.$emit("openModal", params);
    },
    getStatus(status, soldOut, expired) {
      if (status === 1) {
        if (soldOut === 1 || expired === 1) {
          return this.$t("profile.buyers.statusSoldFinished");
        }
        return this.$t("profile.buyers.statusSold");
      } else if (status === 2) {
        return this.$t("profile.buyers.statusBuyerGaveUp");
      } else if (status === 3) {
        return this.$t("profile.buyers.statusRejected");
      } else if (status === 4) {
        return this.$t("profile.buyers.statusRejectedAdmin");
      } else if (status === 5) {
        return this.$t("profile.buyers.statusContract");
      } else {
        return this.$t("profile.buyers.statusUnknown");
      }
    },
    getTagColor(status, soldOut, expired) {
      if (status === 1) {
        if (soldOut === 1 || expired === 1) {
          return "light-blue";
        }
        return "green";
      } else if (status === 2) {
        return "gray";
      } else if (status === 3) {
        return "red";
      } else if (status === 4) {
        return "red";
      } else if (status === 5) {
        return "dark-blue";
      } else {
        return "gray";
      }
    },
    navigateToAd(id, e) {
      e.stopPropagation();
      this.$router.push({
        name: "Details",
        params: { lang: this.$i18n.locale, id: id }
      });
    },
    navigateToHome() {
      this.$router.push({ name: "Berza", params: { lang: this.$i18n.locale } });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.purchases = [];
      this.getMyPurchases();
    },
    createUrl(id) {
      return (
        document.location.origin + "/" + this.$i18n.locale + "/details/" + id
      );
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    seeExpiry(expiry) {
      // 2022-01-30 09:19   - this form parameter get
      // console.log(expiry.substr(0, 4), expiry.substr(5, 2), expiry.substr(8, 2), expiry.substr(11, 2), expiry.substr(14, 2))
      let date = new Date(
        expiry.substr(0, 4),
        expiry.substr(5, 2) - 1,
        expiry.substr(8, 2),
        expiry.substr(11, 2),
        expiry.substr(14, 2)
      );
      return date - new Date() > 1;
    }
  },
  computed: {
    getTranslation() {
      return condition => {
        if (condition === 1) {
          return this.$t("dropdown.condition1");
        } else {
          return this.$t("dropdown.condition2");
        }
      };
    },
    sortList() {
      return [
        {
          label: this.$t("profile.buyers.statusSold"),
          value: "active"
        },
        {
          label: this.$t("profile.buyers.statusBuyerGaveUp"),
          value: "gave-up"
        },
        {
          label: this.$t("profile.buyers.statusRejected"),
          value: "rejected"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/btnStyles.scss";
@import "@/assets/scss/tableStyles.scss";
.profile-my-purchases-wrapper {
  padding-left: 40px;

  .empty {
    text-align: left;
  }

  .dropdown-row {
    td {
      // border-bottom: 1px solid #e8e8e8;
      height: 0px;
      padding: 0px;
      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        height: 0px;
        width: 100%;
        transition-duration: 0.3s;
      }
    }
  }
  .dropdown-row.active {
    cursor: default;
    td {
      border-bottom: none;
      height: auto;
      padding: 0;
      overflow: hidden;
      transition-duration: 0.3s;

      .dropdown {
        height: auto;
        transition-duration: 0.3s;
        border: 1px solid rgba(243, 243, 243, 0.7);
        box-sizing: border-box;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
        padding: 20px;
        .header {
          font-weight: bold;
          font-size: 17px;
          line-height: 28px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }

        .share-and-rate-button {
          display: flex;
          justify-content: space-between;
          gap: 10px;
        }

        .info {
          margin-bottom: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;

          &.share {
            margin-bottom: 0;
            display: flex;
            gap: 5px;
          }

          .info-key {
            font-weight: normal;
            // color: #787878;
            margin-right: 10px;
            white-space: nowrap;
          }
          .info-value {
            // font-weight: 800;
            letter-spacing: 0.02em;
            color: $text-color;
            .share-network-email {
              position: relative;
              .imgShareIcon {
                // position: relative;
                // bottom:-8px;
                position: relative;
                bottom: -4px;
                cursor: pointer;
                height: 35px;
                margin-left: 5px;
              }
            }
          }
          .iconsVal {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
        }
        .dropdown-header {
          display: flex;
          justify-content: space-between;

          div {
            margin-bottom: 15px;
          }
        }
        .info-wrapper {
          display: flex;
          align-items: stretch;
          justify-content: space-between;
          position: relative;
          margin-bottom: 15px;
          gap: 40px;
          color: $text-color;
          font-size: 16px;
          .left {
            flex-basis: 26%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 10px;
          }
          .right {
            flex: 1 1 50%;
          }
          textarea {
            flex-grow: 1;
            resize: none;
          }
        }
        .rate-wrapper {
          display: flex;
          flex-direction: column;

          textarea {
            width: 100%;
          }
        }
      }
    }
  }
  tr.deleted td {
    background: rgba(196, 196, 196, 0.15);
  }
  tbody tr td {
    border-bottom: none;
  }
  tbody tr td .underline {
    text-decoration: underline !important;
  }
  tbody tr {
    cursor: pointer;
  }
  .actions-wrapper {
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .btn-dropdown-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      .btn {
        gap: 5px;
        margin-right: 5px;
      }
    }

    .search-wrapper {
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      input {
        border: none;
        border-bottom: 1px solid #ddd;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        height: 20px;
        line-height: 20px;
        padding-right: 20px;
        font-weight: bold;
        font-size: 13px;
        line-height: 15px;
        letter-spacing: 0.02em;
        color: $text-color;
        max-width: 230px;
      }
      input::placeholder {
        font-weight: bold;
        font-size: 13px;
        letter-spacing: 0.04em;
        color: $text-color;
      }
      input:focus {
        outline: none;
      }
      img {
        position: absolute;
        right: 0;
        cursor: pointer;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    .actions-wrapper {
      flex-direction: column;
      .btn {
        margin-bottom: 40px;
      }
    }
  }
}
</style>
